
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BaseError": [
      "AuthenticationError",
      "BookmarkMutation_DuplicatedPlaceError",
      "BookmarkMutation_ExceedFolderMappingMaxCountError",
      "BookmarkMutation_ExceedMaxBookmarkInDefaultFolderCount",
      "BookmarkMutation_ExceedMaxBookmarkInFolderCount",
      "BookmarkMutation_ExceedMaxTotalBookmarkCountError",
      "BookmarkMutation_ExceedPlaceGroupMaxBookmarkCount",
      "BookmarkMutation_InvalidParamsError",
      "CleanBotError",
      "CreateReviewGroup_Duplicated",
      "CreateReviewGroup_NoContent",
      "CreateReviewGroup_SelectedProofNotFound",
      "DeleteReviewGroup_ReviewGroupNotFound",
      "EntityError",
      "ForbiddenError",
      "MaxCacheCountError",
      "Me_NotLoginError",
      "Me_UserNotFoundError",
      "MobileAppOnlyError",
      "NotFoundError",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength",
      "ReviewGroupWriteNotSupportedProof_Error",
      "Timeline_NotFound",
      "TrailerFailed",
      "UpdateGreyUserUnavailableFailed",
      "UpdateReviewGroup_NoContent",
      "UpdateReviewGroup_ReviewGroupNotFound",
      "UpdateReviewGroup_ReviewGroupSuspended",
      "UpdateReviewGroup_SelectedProofNotFound"
    ],
    "Bookmark": [
      "AddressBookmark",
      "PlaceBookmark"
    ],
    "CalendarTimelinesPayload": [
      "AuthenticationError",
      "CalendarTimelinesSucceed"
    ],
    "CreatePlaceBookmarkPayload": [
      "BookmarkMutation_DuplicatedPlaceError",
      "BookmarkMutation_ExceedFolderMappingMaxCountError",
      "BookmarkMutation_ExceedMaxBookmarkInDefaultFolderCount",
      "BookmarkMutation_ExceedMaxBookmarkInFolderCount",
      "BookmarkMutation_ExceedMaxTotalBookmarkCountError",
      "BookmarkMutation_ExceedPlaceGroupMaxBookmarkCount",
      "BookmarkMutation_InvalidParamsError",
      "CreatePlaceBookmark_Succeed"
    ],
    "CreateReviewGroupOutput": [
      "CleanBotError",
      "CreateReviewGroup_Duplicated",
      "CreateReviewGroup_NoContent",
      "CreateReviewGroup_SelectedProofNotFound",
      "CreateReviewGroup_Succeed",
      "MobileAppOnlyError",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength"
    ],
    "CurrentMissionSummariesOutput": [
      "CurrentMissionSummariesSucceed"
    ],
    "DeleteBookmarkPayload": [
      "BookmarkMutation_InvalidParamsError",
      "DeleteBookmark_Succeed"
    ],
    "DeleteReviewGroupOutput": [
      "DeleteReviewGroup_ReviewGroupNotFound",
      "DeleteReviewGroup_Succeed"
    ],
    "DeleteTimelinePayload": [
      "AuthenticationError",
      "DeleteTimeline_Succeed",
      "ForbiddenError"
    ],
    "FeedsOutput": [
      "Feeds_Succeed"
    ],
    "FrequentPlaceCommon": [
      "FrequentAddress",
      "FrequentPlace",
      "FrequentSubway"
    ],
    "HideVisitOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "HideVisitSucceed",
      "MaxCacheCountError",
      "NotFoundError"
    ],
    "MePayload": [
      "MeSucceed",
      "Me_NotLoginError",
      "Me_UserNotFoundError"
    ],
    "MediaItem": [
      "ImageItem",
      "VideoItem"
    ],
    "MySectionsPayload": [
      "MySectionsSucceed"
    ],
    "Proof": [],
    "RecentVisitsWithoutReviewOutput": [
      "RecentVisitsWithoutReview_Succeed"
    ],
    "ReviewGroupWriteFormByReviewGroupPayload": [
      "ReviewGroupWriteFormByReviewGroupSucceed",
      "ReviewGroupWriteNotSupportedProof_Error"
    ],
    "ReviewGroupWriteFormByVisitPayload": [
      "ReviewGroupWriteFormByVisitSucceed",
      "ReviewGroupWriteNotSupportedProof_Error"
    ],
    "ReviewGroupWriteUIConfig": [
      "ReviewGroupWriteHeaderSection",
      "ReviewGroupWriteKeywordSection",
      "ReviewGroupWriteLikePlaceSection",
      "ReviewGroupWriteMediaSection",
      "ReviewGroupWritePaymentSection",
      "ReviewGroupWritePovSelectionSection",
      "ReviewGroupWriteStarRatingSection",
      "ReviewGroupWriteTextSection",
      "ReviewGroupWriteVisitInfoSection",
      "ReviewGroupWriteVisitSummarySection"
    ],
    "ReviewGroupsOutput": [
      "ReviewGroups_MaxCountError",
      "ReviewGroups_Succeed"
    ],
    "SectionUIConfig": [
      "BookingBannerSection",
      "BookingTrendPickSection",
      "DDayRecommendationSection",
      "DailyBriefingSection",
      "FooterSection",
      "FrequentPlaceSection",
      "MYDrivingSection",
      "MissionSection",
      "MobileSubADSection",
      "MobileSubADSection2",
      "MyReviewImpactSection",
      "ProfileSection",
      "RecentBookingSection",
      "RecentFollowingReviewsSection",
      "RecentPlaceBookmarkSection",
      "SeatAlertSection",
      "ShortcutSection",
      "SmartChannelADSection",
      "TimelineCalendarSection",
      "TimelineSection",
      "UnwrittenReviewSection",
      "UpcomingSection"
    ],
    "SignUpOutput": [
      "AuthenticationError",
      "ForbiddenError",
      "NotFoundError",
      "SignUp_Succeed"
    ],
    "Timeline": [
      "CheckInTimeline",
      "HotelTimeline",
      "NFTTimeline",
      "OrderTimeline",
      "PaymentTimeline",
      "ReceiptTimeline",
      "ReservationTimeline",
      "TrainTicketTimeline"
    ],
    "TimelineListPageConfigPayload": [
      "TimelineListPageConfigSucceed"
    ],
    "TimelinePayload": [
      "Timeline_NotFound",
      "Timeline_Succeed"
    ],
    "TimelinesPayload": [
      "AuthenticationError",
      "TimelinesSucceed"
    ],
    "TrailerOutput": [
      "TrailerFailed",
      "TrailerSucceed"
    ],
    "TrainTicketBase": [
      "CancelledTrainTicket",
      "UpcomingTrainTicket"
    ],
    "UpdateGreyUserUnavailableOutput": [
      "AuthenticationError",
      "UpdateGreyUserUnavailableFailed",
      "UpdateGreyUserUnavailableSucceed"
    ],
    "UpdateReviewGroupOutput": [
      "CleanBotError",
      "MobileAppOnlyError",
      "ReviewGroupKeywordNotValid",
      "ReviewGroupOverflowMaxKeywordCount",
      "ReviewGroupOverflowMaxTextLength",
      "UpdateReviewGroup_NoContent",
      "UpdateReviewGroup_ReviewGroupNotFound",
      "UpdateReviewGroup_ReviewGroupSuspended",
      "UpdateReviewGroup_SelectedProofNotFound",
      "UpdateReviewGroup_Succeed"
    ],
    "UserReviewGroupsOutput": [
      "EntityError",
      "UserReviewGroupsConnection"
    ]
  }
};
      export default result;
    